<template>
    <div class="section">
        <Login />
        <div  v-if="user && !user.isAnonymous"  class="container">
            <h1 class="title is-2">Tag Admin Page</h1>
            
            
            <div class="section">
                <h2 class="title is-4">Approve New Tags</h2>
                <!-- <pre>{{tagsToApprove}}</pre> -->
                <div style="text-align:left" v-for="(tagdata, idx) in tagsToApprove"
                    v-bind:key="tagdata.tag + tagdata.pageid + idx">
                    {{tagdata.tag}} - {{tagdata.tagtype}} - {{tagdata.continent}} - 
                    <a v-bind:href="tagdata.pageid" target="_blank">{{tagdata.pageid}}</a>
                    <b-button @click="approveTag(tagdata)">Approve</b-button><b-button @click="rejectTag(tagdata)">Reject</b-button>
                    </div>


            </div>

            <form class="section">
                <h2 class="title is-4">Get Data for Page</h2>
                <b-field >
                    <b-input required  placeholder="url" type="text" v-model="url" size="is-medium"></b-input>
                </b-field>
                
                <b-button type="submit" @click="getDataForPage(url)">Get Data</b-button>
                <!-- <pre style="text-align:left">{{Object.keys(adminPageData).sort()}}</pre> -->
                <pre style="text-align:left"> {{Object.keys(adminPageData).sort().reduce(
                    (obj, key) => { 
                        obj[key] = adminPageData[key]; 
                        return obj;
                    }, 
                    {}
                    )}}</pre>

            </form>

            <form class="section">
                <h2 class="title is-4">Change or Add STRING FIELD for Page</h2>
                <b-field >
                    <b-input   placeholder="url" type="text" v-model="url" size="is-medium"></b-input>
                </b-field>
                <b-field >
                    <b-input   placeholder="field to change" type="text" v-model="fieldtochange" size="is-medium"></b-input>
                </b-field>
                <b-field >
                    <b-input   placeholder="new value" type="text" v-model="newvalue" size="is-medium"></b-input>
                </b-field>
                
                <b-button type="submit" @click="changeDataForPage(url, fieldtochange, newvalue)">Change Data</b-button>
                <p>{{changeDataResult}}</p>

            </form>

            <form class="section">
                <h2 class="title is-4">Change or Add BOOLEAN FIELD for Page</h2>
                <b-field >
                    <b-input   placeholder="url" type="text" v-model="url" size="is-medium"></b-input>
                </b-field>
                <b-field >
                    <b-input   placeholder="field to change" type="text" v-model="fieldtochange" size="is-medium"></b-input>
                </b-field>
                
                <b-field>
                    <p>New value </p>
                    <b-switch v-model="switchValue">
                        {{switchValue}}
                    </b-switch>
                </b-field>
                <b-button type="submit" @click="changeDataForPage(url, fieldtochange, switchValue)">Change Data</b-button>
                <p>{{changeDataResult}}</p>

            </form>

            <form class="section">
                <h2 class="title is-4">Change Tag Text</h2>
                <b-field >
                    <b-input required  placeholder="tag type (ridertags, routes, etc)" type="text" v-model="tagtype" size="is-medium"></b-input>
                </b-field>
                <b-field >
                    <b-input required placeholder="old text" type="text" v-model="oldtag" size="is-medium"></b-input>
                </b-field>
                <b-field >
                    <b-input required placeholder="new text" type="text" v-model="newtag" size="is-medium"></b-input>
                </b-field>
                <b-button type="submit" @click="changeTag(tagtype, oldtag, newtag)">Change Old to New</b-button>
                <b-button type="submit" @click="deleteTag(tagtype, oldtag)">Delete Old</b-button>

            </form>

            <form class="section">
                <h2 class="title is-4">Add New Route</h2>
                <!-- <b-field >
                    <b-input required  placeholder="tag type (ridertags, routes, etc)" type="text" v-model="tagtype" size="is-medium"></b-input>
                </b-field> -->
                <b-field >
                    <b-input required placeholder="route name" type="text" v-model="newRoute" size="is-medium"></b-input>
                </b-field>
                <p>{{addRouteResult}}</p>
                <!-- <b-field >
                    <b-input required placeholder="new text" type="text" v-model="newtag" size="is-medium"></b-input>
                </b-field> -->
                <b-button type="submit" @click="addRoute(newRoute)">Add Route</b-button>
                <!-- <b-button type="submit" @click="deleteTag(tagtype, oldtag)">Delete Old</b-button> -->
                
            </form>


            <br><br>
            <b-button @click="adminFunction">Run admin function</b-button>

        </div>

        
     
    </div>  
</template>

<script>
// import {allcountries} from "../data.js";
import { continent_map} from "../data.js";
import Login from '@/components/Login';
export default {
    name: 'AdminTags',
    components: {Login},
    data () {
        return {
            tagtype:"",
            oldtag: "",
            newtag: "",
            url: "",
            tagsToApprove: [],
            newRoute: "",
            addRouteResult: "",
            adminPageData: {},

            fieldtochange: "",
            newvalue: "",
            switchValue: false,
            changeDataResult: ""
            // allcountries: allcountries
        }
    
    },
    computed: {
     user: function() {
            return this.$getParent('App').user;
        }
    },
    methods: {
        keyify(str) {
            return encodeURI(str.toLowerCase());
        },
        approveTag(tagdata) {
            // add to tags
            this.addTagToTags(tagdata.tag, tagdata.tagtype);
            var that = this;
            if (tagdata.tagtype == "routes") {
                console.log("Adding to routes collection");
                var data = {display_name: tagdata.tag, type: 'route', url_path: that.keyify(tagdata.tag) };
                if (tagdata.continent) {
                    data['continent'] = tagdata.continent;
                }
                if (tagdata.countries) {
                    data['countries'] = tagdata.countries;
                }
                this.$db.collection("routes").doc(that.keyify(tagdata.tag)).set( data, {merge: true});
            }
            if (tagdata.tagtype == "ridertags") {
                console.log("Adding to ridertags collection");
                this.$db.collection("ridertags").doc(that.keyify(tagdata.tag)).set( {display_name: tagdata.tag, type: 'ridertag', url_path: that.keyify(tagdata.tag) }, {merge: true});
            }

            // add to pages
            // get all pages with the new tag
            var that = this;
            this.$db.collection("tags_unapproved").where("tag", "==", tagdata.tag).where("tagtype", "==", tagdata.tagtype).get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // pagesWithTag.push(doc.data().pageid);
                    // unapprovedTagIds.push(doc.id);
                    that.addTagToPage(tagdata.tag, tagdata.tagtype, doc.data().pageid, "pages");
                    that.addTagToPage(tagdata.tag, tagdata.tagtype, doc.data().pageid, "pages_unapproved");
                    doc.ref.delete();

                });
               
            }).catch(function(error) {
                console.log(error);
            }); 
        },
        rejectTag(tagdata) {
            // this.$db.collection("tags_unapproved").doc(tagdata.id).delete();
            this.$db.collection("tags_unapproved").where("tag", "==", tagdata.tag).where("tagtype", "==", tagdata.tagtype).get().then(function(querySnapshot) {   
                querySnapshot.forEach(function(doc) {
                    doc.ref.delete();
                });
            }).catch(function(error) {
                console.log(error);
            }); 
        },
        deleteTag(tagtype, oldtag) { // clean and tested
            if (tagtype != "" && oldtag != "") {
                var that = this;    
                this.removeTagFromTags(oldtag, tagtype);
              
                //change in all pages
                this.$db.collection("pages").where(tagtype, "array-contains", oldtag).get().then(function(querySnapshot) {
                   querySnapshot.forEach(function(doc) {
                        that.removeTagFromPage(oldtag, tagtype, doc.id, "pages");
                    });
                }).catch(function(error) {
                    console.log(error);
                }); 
                this.$db.collection("pages_unapproved").where(tagtype, "array-contains", oldtag).get().then(function(querySnapshot) {
                   querySnapshot.forEach(function(doc) {
                        that.removeTagFromPage(oldtag, tagtype, doc.id, "pages_unapproved");
                    });
                }).catch(function(error) {
                    console.log(error);
                });

            }
            this.tagtype = "";
            this.oldtag = "";
            this.newtag = "";

        },
        getDataForPage(url) {
            var that = this;
            this.$db.collection("pages").where("url", "==", url)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());
                        that.adminPageData = doc.data();
                    });
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });
        },
        changeDataForPage(url, fieldname, newvalue) {
            this.changeDataResult = "";
            var that = this;

            this.$db.collection("pages").where("url", "==", url)
                .get()
                .then((querySnapshot) => {
                    querySnapshot.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        console.log(doc.id, " => ", doc.data());
                        
                        var updateDoc = {};
                        updateDoc[fieldname] = newvalue;
                        that.$db.collection("pages").doc(doc.id).set(updateDoc, {merge: true})
                        .then(() => {
                            console.log("Document successfully written!");
                            that.changeDataResult = "Success!"
                        })
                        .catch((error) => {
                            console.error("Error writing document: ", error);
                            that.changeDataResult = ":("
                        });



                    });
                })
                .catch((error) => {
                    console.log("Error getting documents: ", error);
                });
               
        },
        changeTag(tagtype, oldtag, newtag) { // clean and tested
           if (tagtype != "" && oldtag != "" && newtag != "") {
                var that = this;
                this.addTagToTags(newtag, tagtype)
                    .then(that.removeTagFromTags(oldtag, tagtype))
                    .catch(function(error) {
                        console.log(error);
                    });
                    
               var that = this;
               this.$db.collection("pages").where(tagtype, "array-contains", oldtag).get().then(function(querySnapshot) {
                   querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        that.addTagToPage(newtag, tagtype, doc.id, "pages")
                            .then(that.removeTagFromPage(oldtag, tagtype, doc.id, "pages"))
                            .catch(function(error) {
                                console.log(error);
                            }); 
                    });
               }).catch(function(error) {
                    console.log(error);
                });
               this.$db.collection("pages_unapproved").where(tagtype, "array-contains", oldtag).get().then(function(querySnapshot) {
                   querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                        that.addTagToPage(newtag, tagtype, doc.id, "pages_unapproved")
                            .then(function(result) {
                                console.log("Add tag to page completed with result: " + result + " , now we're removing the old tag");
                                that.removeTagFromPage(oldtag, tagtype, doc.id, "pages_unapproved");
                            })
                            .catch(function(error) {
                                console.log(error);
                            });
                    });
               }).catch(function(error) {
                    console.log(error);
                });
               if (tagtype == "routes") {
                   this.$db.collection("routes").doc(encodeURI(oldtag.toLowerCase())).set({display_name: newtag},  { merge: true });
               }
           }
            this.tagtype = "";
            this.oldtag = "";
            this.newtag = "";
        },
        addTagToPage(tag, tagtype, pageid, pagetype) {
            return new Promise((resolve, reject) => {
                var toAdd = {};
                toAdd[tagtype] = this.$firebase.firestore.FieldValue.arrayUnion(tag);
                this.$db.collection(pagetype).doc(pageid).update(toAdd)
                .then(function() {
                    console.log("added tag " + tag + " to page " + pageid + ' in collection ' + pagetype);
                    resolve("success");
                })
                .catch(function(error) {
                    reject(error);
                    // The document probably doesn't exist.
                    // console.log("Error adding tag "  + tag + " to page " + pageid + ' in collection ' + pagetype, error);
                }); 
            })
            
        },
        removeTagFromPage(tag, tagtype, pageid, pagetype) {
            var toRemove = {};
            toRemove[tagtype] = this.$firebase.firestore.FieldValue.arrayRemove(tag);
            // this.$db.collection(pagetype).doc(pageid).update(toRemove);
            this.$db.collection(pagetype).doc(pageid).update(toRemove)
                .then(function() {
                    console.log("removed tag " + tag + " from page " + pageid + ' in collection ' + pagetype);
                })
                .catch(function(error) {
                    // The document probably doesn't exist.
                    // console.log("Error adding tag "  + tag + " to page " + pageid + ' in collection ' + pagetype, error);
                }); 
        },
        addTagToTags(tag, tagtype) {
            return new Promise((resolve, reject) => {
                console.log("We're in the addTagToTags promise");
                var toAdd = {};
                toAdd[tagtype] = this.$firebase.firestore.FieldValue.arrayUnion(tag);
                this.$db.collection("tags").doc(tagtype).update(toAdd)
                    .then(function() {
                        resolve("success");
                    })
                    .catch(function(error) {
                        reject(error);
                    });
            });
        
            
        },
        removeTagFromTags(tag, tagtype) {
            var toRemove = {};
            toRemove[tagtype] = this.$firebase.firestore.FieldValue.arrayRemove(tag);
            this.$db.collection("tags").doc(tagtype).update(toRemove);
        },
        addRoute(route) {
            // var message = "";
            var that = this;
            that.addRouteResult = "";
            this.$db.collection("routes").doc(that.keyify(route)).set( {display_name: route, type: 'route', url_path: that.keyify(route) }, {merge: true})
                .then(function() {
                        console.log("success");
                        that.addRouteResult = that.addRouteResult + "Added to routes collection: success. ";
                    })
                    .catch(function(error) {
                        console.log(error);
                        that.addRouteResult = that.addRouteResult + "Added to routes collection: failure: " + error + " ";
                    })
             

            var tagAddResult = this.addTagToTags(route, "routes");
            if (tagAddResult) {
                that.addRouteResult = that.addRouteResult + "Added to routes array: success. ";
            } else {
                that.addRouteResult = that.addRouteResult + "Added to routes array: failure: ";
            }
        },
        keyify(thing) {
            return encodeURI(thing.toLowerCase());
        },
        adminFunction() {
            // var routename = "Arizona Trail";
            // this.$db.collection("routes").doc(this.keyify(routename)).set( {display_name: routename, type: 'route', url_path: this.keyify(routename), continent: "North America" }, {merge: true}).then(function() {
            //     console.log("Added route");

            // }).catch(function(error) {
            //         console.log("Error adding route: " + error);
            //         return {result: "Error adding route: " + error};
            //     });
            // var that = this;
            // this.$db.collection('pages').where("site_name", "==", "Faults and Folds").get()
            //     .then(function(querySnapshot) {
            //         querySnapshot.forEach(function(doc) {
            //             var docid = doc.id;
            //             var docData = doc.data();
            //                console.log("Setting site_domain for doc ", docid);
            //             that.$db.collection('pages').doc(docid).set( {site_domain: 'faultsandfolds.com'}, {merge: true});
                        
            //         });
                        
                        
            //     }).catch(function(error) {
            //         console.log("Error : " + error);
            //         return {result: "Error : " + error};
            //     });
        },
        adminFunctionMoodtoFeature() {
           var that = this;
            this.$db.collection("pages").where("mood", "array-contains", "mountainous").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    var pageData = doc.data();
                    var pageId = doc.id;

                    var updatedFeatures = [];
                    if (pageData.features) {
                        updatedFeatures = pageData.features;
                    }
                    if (!updatedFeatures.includes('mountains')) {
                      
                        updatedFeatures.push('mountains');
                    }
                    // console.log(pageId, " - ", pageData.mood);
                    console.log("Updating page ", pageId);
                    console.log("mood: ", pageData.mood);
                    console.log("existing features: ", pageData.features);
                    console.log("new features", updatedFeatures);
                    that.$db.collection('pages').doc(pageId).set({features: updatedFeatures},  { merge: true });
                });
            });
        },


        adminFunctionBroken() {
            // replace route data with keys
            var that = this;
            this.$db.collection("pages").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    var pageData = doc.data();
                    var pageId = doc.id;
                    var routes = pageData.routes;
                    var routes_new = [];
                    if (routes && routes.length > 0) {
                        console.log("setting doc with id " + pageId + " to have routes_old field ");
                        console.log(routes);
                        // that.$db.collection("pages").doc(pageId).set({routes_old: routes},  { merge: true });

                        routes.forEach(function(oldroute) {
                            that.$db.collection('routes').where("display_name", "==", oldroute).get().then(function(querySnapshot) {
                                querySnapshot.forEach(function(innerdoc) {
                                    console.log(innerdoc.data());
                                    var innerID = innerdoc.id;
                                    var innerData = innerdoc.data();
                                    console.log(innerID);
                                    if (innerID) {
                                        routes_new.push(innerID);
                                    }
                                });
                            });

                        });

                    }
                    console.log(routes_new);
                });
            });
            // this.$db.collection('routes')

        },
        adminFunctionRoutes() {
            var that = this;
            var uniqueSites = [];
            var uniqueCountries = {};
            var uniqueRoutes = {};
            var uniqueContinents = {};
            var pageCount = 0;
            // console.log("fetching totals");
            this.$db.collection('pages').get().then(function(querySnapshot) {
                console.log("fetched");
                pageCount = querySnapshot.size;
                console.log("Page count: " + pageCount);
                querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                    var pageData = doc.data();
                    pageData.routes.forEach(function(routeDisplayName) {

                        var routeKey = that.keyify(routeDisplayName);

                        if (routeKey in uniqueRoutes) {
                            var dataObj = uniqueRoutes[routeKey];
                            dataObj.post_count = dataObj.post_count + 1;
                        } else {
                            uniqueRoutes[routeKey] = {post_count: 1, display_name: routeDisplayName};
                        }
                    });
             
                });

                console.log("routes list: ");
                console.log(uniqueRoutes);

                if (Object.keys(uniqueRoutes).length > 0) {
                    console.log("yup");
                    // this.$db.collection('counts').doc('totals').set({_continents:uniqueContinents.length},  { merge: true });
                    for (const keyified in uniqueRoutes) {
                        var data = {};
                        // var id = keyify(pageData.continent);
                        data.display_name = uniqueRoutes[keyified].display_name;
                        data.post_count = uniqueRoutes[keyified].post_count;
                        data.type = "route";
                        data.url_path = keyified;
                        console.log(data);
                        that.$db.collection('routes').doc(keyified).set(data,  { merge: true });
                    }
                    // return pageCount;
                }
            });
        },
        adminFunctionContinents() {
            var that = this;
            var uniqueSites = [];
            var uniqueCountries = {};
            var uniqueRoutes = [];
            var uniqueContinents = {};
            var pageCount = 0;
            // console.log("fetching totals");
            this.$db.collection('pages').get().then(function(querySnapshot) {
                console.log("fetched");
                pageCount = querySnapshot.size;
                console.log("Page count: " + pageCount);
                querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                    var pageData = doc.data();

                    var continentKey = that.keyify(pageData.continent);
                    if (continentKey in uniqueContinents) {
                        var dataObj = uniqueContinents[continentKey];
                        dataObj.post_count = dataObj.post_count + 1;
                    } else {
                        uniqueContinents[continentKey] = {post_count: 1, display_name: pageData.continent, url_path: continentKey, type: "continent"};
                    }
             
                });

                //  for (const keyifiedContinent in uniqueContinents) { // update detailed count for each continent  
                //     that.$db.collection('continents_test').doc(keyifiedContinent).set({post_count: uniqueContinents[keyifiedContinent].count},  { merge: true });
                // }

                console.log("countries list: ");
                console.log(uniqueContinents);

                if (Object.keys(uniqueContinents).length > 0) {
                    console.log("yup");
                    for (const keyified in uniqueContinents) {
                        that.$db.collection('continents').doc(keyified).set(uniqueContinents[keyified],  { merge: true });
                    }
                }
            });
        },
        adminFunctionCountries() {
            var that = this;
            var uniqueSites = [];
            var uniqueCountries = {};
            var uniqueRoutes = [];
            var uniqueContinents = {};
            var pageCount = 0;
            // console.log("fetching totals");
            this.$db.collection('pages').get().then(function(querySnapshot) {
                console.log("fetched");
                pageCount = querySnapshot.size;
                console.log("Page count: " + pageCount);
                querySnapshot.forEach(function(doc) {
                        // doc.data() is never undefined for query doc snapshots
                    var pageData = doc.data();
                    pageData.countries.forEach(function(code) {

                        var countryKey = that.keyify(that.$countrymap[code]);

                        if (countryKey in uniqueCountries) {
                            var dataObj = uniqueCountries[countryKey];
                            dataObj.post_count = dataObj.post_count + 1;
                        } else {
                            uniqueCountries[countryKey] = {post_count: 1, code: code};
                        }
                    });
             
                });

                for (const allcode in that.$countrymap) {
                    if (!(that.keyify(that.$countrymap[allcode]) in uniqueCountries)) {
                        uniqueCountries[that.keyify(that.$countrymap[allcode])] = {post_count: 0, code: allcode, display_name: that.$countrymap[allcode]};
                    }
                }

                console.log("countries list: ");
                console.log(uniqueCountries);

                if (Object.keys(uniqueCountries).length > 0) {
                    console.log("yup");
                    // this.$db.collection('counts').doc('totals').set({_continents:uniqueContinents.length},  { merge: true });
                    for (const keyified in uniqueCountries) {
                        var data = {};
                        // var id = keyify(pageData.continent);
                        data.code = uniqueCountries[keyified].code;
                        data.display_name = that.$countrymap[data.code];
                        data.post_count = uniqueCountries[keyified].post_count;
                        data.type = "country";
                        data.url_path = that.keyify(data.display_name);
                        console.log(data);
                        that.$db.collection('countries').doc(data.code).set(data,  { merge: true });
                    }
                    // return pageCount;
                }
            });
        },


        adminFunction2() {
           // add continent to each page (also need to add it going forward)

            // add domain to each page (also need to add it going forward)
           var that = this;
           this.$db.collection("pages").get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id);
                    
                    var surfaces = doc.data().surfaces;
                    console.log(surfaces);
                    if (surfaces.includes("steep")) {
                        const index = surfaces.indexOf("steep");
                        surfaces[index] = "mountainous"
                    }
                    // var url = doc.data().url;
                    // var domain = doc.data().url.split('://')[1].split('/')[0];
                    // countrycodes.forEach(function(code) {
                    // var match = continent_map.find(elem => elem["Two_Letter_Country_Code"] == countrycode);
                    // continent = match["Continent_Name"];
                    // });
                    
                    
                    console.log(surfaces);
                    // console.log(continent);

                    // that.$db.collection("pages").doc(doc.id).set({surfaces: surfaces}, { merge: true })
                    // var toChange = page[tagtype];
                    // // console.log(toChange);
                    // // console.log(doc.id, " => ", doc.data());
                    // that.$db.collection("pages").doc(doc.id).update(toAdd);
                    // that.$db.collection("pages").doc(doc.id).update(toRemove);
                });
            });

       }
  
        
    },
    mounted() {
        var that = this;
        this.$db.collection("tags_unapproved").onSnapshot(function(querySnapshot) {
            var result = [];
            querySnapshot.forEach(function(doc) {
                // doc.data() is never undefined for query doc snapshots
                var stuff = doc.data();
                stuff['id'] = doc.id;
                
                result.push(stuff);
                // console.log(doc.id, " => ", doc.data());
            });
            that.tagsToApprove = result;
        });
      
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 
</style>






// WEBPACK FOOTER //
// src/components/AdminTags.vue